// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"2f7d4d52","186":"f12dd18d","208":"2a176eb4","270":"f3220869","300":"f2f99ce6","401":"82ede3ff","470":"203a87cc","574":"02bee00e","642":"850e2f36","787":"70e1634a","845":"2fbcf623"}[chunkId] + ".chunk.js";
};